import { FuelGridContainer } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';

export const Container = styled(FuelGridContainer)`
  ${({ theme: { spacing } }) => css`
    padding-top: ${spacing.km10};
    padding-bottom: ${spacing.km12};
  `}
`;

export const ProgressContainer = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-gap: ${spacing.km2};
  `}
`;

export const StepsContainer = styled.div`
  ${() => css`
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
  `}
`;
